document.addEventListener("DOMContentLoaded", function () {
  var navigationSelect = document.querySelector('.filter-selectors');
  var navigationSelect2 = document.querySelector('.filter-col-selector-wrap');

  function initSelect(elem){
    var selectHolder = elem.querySelector('.filter-selector-val');
    var selectOptions = elem.querySelectorAll('.filter__list li');
    var dropHolder = elem.querySelector('.filter-selector-title');
    var selectedOption = selectOptions[0];

    //selectedOption.classList.add('current');
    selectHolder.addEventListener('click', function (event) {  
          event.stopPropagation();
      closeOtherDropdowns(dropHolder);
        if (!dropHolder.classList.contains('active')) {
          dropHolder.classList.add('active');
        } else {
          dropHolder.classList.remove('active');
        }
    });

    selectOptions.forEach(function(currentElement) {
      currentElement.addEventListener('click', function(){      
        selectedOption.classList.remove('current');
        selectedOption = currentElement;
        currentElement.classList.add('current');
        selectHolder.innerText = currentElement.querySelector('.filter-checkbox__text').textContent;      
        selectHolder.setAttribute('data-value-selected', 'true');
        dropHolder.classList.remove('active');
      });
    });
  };

    function closeOtherDropdowns(openDropHolder) {
    var allDropdowns = [navigationSelect, navigationSelect2];
    allDropdowns.forEach(function(dropdown) { 
        var dropHolder = dropdown.querySelector('.filter-selector-title');
        if (dropHolder !== openDropHolder && dropHolder.classList.contains('active')) {
          dropHolder.classList.remove('active');
        }
    });
  }
  document.addEventListener('click', function() {
    closeOtherDropdowns(); // Close all dropdowns if clicking outside
  });  
  if(navigationSelect){   initSelect(navigationSelect); }
  if(navigationSelect2){  initSelect(navigationSelect2); }

  
  document.querySelector('.filter-search-btn').addEventListener('click', function(eve) {
      eve.preventDefault();  
      var is_filter_active = false;  
      var is_filter_selected = 'false';
      if(navigationSelect){
          const get_filter_element = navigationSelect.querySelector('.filter-selector-val');  
          if(get_filter_element){
            var is_filter_selected = get_filter_element.getAttribute('data-value-selected');
            var is_filter_active = true;
          }
      }
      var is_collection_selected = false;
      var is_collection_selected = 'false';
      if(navigationSelect2){
      const get_collection_element = navigationSelect2.querySelector('.filter-selector-val');
        if(get_collection_element){
          var is_collection_selected = get_collection_element.getAttribute('data-value-selected');
          var is_collection_active = true;
        }   
      }
    if(is_filter_active && is_collection_active){   

        var get_parent =  eve.target.closest('.filter-search-modal');
        var get_search_term = get_parent.querySelector('.search__input').value;
        const queryKey = get_search_term.replace(' ', '+');  
      
      if (is_filter_selected === 'true' && is_collection_selected === 'true') {
          //document.querySelector('.top-filter-selector-wrap').classList.remove('filter-val-empty');      
          const filter_col_element = document.querySelector('.filter-col-selector-wrap');
          const get_selected_collection = filter_col_element.querySelector('.filter__item.current .filter-checkbox__text');  
          const collection_handle = get_selected_collection.getAttribute('data-collection-handle'); 

          const filter_element = document.querySelector('.filter-selectors');
          const get_selected_filter = filter_element.querySelector('.filter__item.current .filter-checkbox__text');  
          const filter_val = get_selected_filter.getAttribute('data-value');    
          if(queryKey){
            window.location.href = '/search?sort_by=relevance&q='+queryKey;   
          }else{
            window.location.href = '/collections/'+collection_handle+'?sort_by=title-ascending&filter.p.t.category='+filter_val;  
          }
                  
      } else if (is_filter_selected === 'false' && is_collection_selected === 'true') {
          const filter_col_element = document.querySelector('.filter-col-selector-wrap');
          const get_selected_collection = filter_col_element.querySelector('.filter__item.current .filter-checkbox__text');  
          const collection_handle = get_selected_collection.getAttribute('data-collection-handle'); 
        window.location.href = '/collections/'+collection_handle+'?sort_by=title-ascending';     
        
      }  else if (is_filter_selected === 'true' && is_collection_selected === 'false') {
          const filter_element = document.querySelector('.filter-selectors');
          const get_selected_filter = filter_element.querySelector('.filter__item.current .filter-checkbox__text');  
          const filter_val = get_selected_filter.getAttribute('data-value');    
          window.location.href = '/search?sort_by=relevance&q='+queryKey+'&filter.p.t.category='+filter_val;   
      }else {
        //document.querySelector('.top-filter-selector-wrap').classList.add('filter-val-empty');          
        const get_search_url = eve.target.getAttribute('data-search-url');          
        window.location.href = get_search_url+'?q='+queryKey;         
      }
  }else if(!is_filter_active && is_collection_active){    
      if (is_collection_selected === 'true') {
          document.querySelector('.top-filter-selector-wrap').classList.remove('filter-val-empty');
        
          const filter_col_element = document.querySelector('.filter-col-selector-wrap');
          const get_selected_collection = filter_col_element.querySelector('.filter__item.current .filter-checkbox__text');  
          const collection_handle = get_selected_collection.getAttribute('data-collection-handle');   
          window.location.href = '/collections/'+collection_handle+'?sort_by=title-ascending';         
      } else {
        //document.querySelector('.top-filter-selector-wrap').classList.add('filter-val-empty');
        var get_parent =  eve.target.closest('.filter-search-modal');
        var get_search_term = get_parent.querySelector('.search__input').value;
        const queryKey = get_search_term.replace(' ', '+');      
        const get_search_url = eve.target.getAttribute('data-search-url');          
        window.location.href = get_search_url+'?q='+queryKey;       
      }        
    }else if(is_filter_active && !is_collection_active){
      var get_parent =  eve.target.closest('.filter-search-modal');
        var get_search_term = get_parent.querySelector('.search__input').value;
        const queryKey = get_search_term.replace(' ', '+');    
      
        if (is_filter_selected === 'true') {
          document.querySelector('.top-filter-selector-wrap').classList.remove('filter-val-empty');     

          const filter_element = document.querySelector('.filter-selectors');
          const get_selected_filter = filter_element.querySelector('.filter__item.current .filter-checkbox__text');  
          const filter_val = get_selected_filter.getAttribute('data-value');    
          window.location.href = '/search?sort_by=title-ascending&filter.p.t.category='+filter_val;         
      } else {
        //document.querySelector('.top-filter-selector-wrap').classList.add('filter-val-empty');        
        const get_search_url = eve.target.getAttribute('data-search-url');          
        window.location.href = '/search?sort_by=relevance&q='+queryKey+'&filter.p.t.category='+filter_val;        
      }
    }
    
  }); 
})